import {
  CAMPAIGN_MESSAGE_TEMPLATE_LIMITS,
  type CampaignChannelKind,
} from '@workspace/types';
import { MESSAGE_TEMPLATE_PREVIEW_VALUES, renderNamedTemplate } from '@workspace/utils';

export function MessageTemplatePreview({
  channelKind,
  subject,
  bodyText,
}: {
  channelKind: CampaignChannelKind;
  subject?: string;
  bodyText: string;
}) {
  const renderedBody = renderNamedTemplate(bodyText, MESSAGE_TEMPLATE_PREVIEW_VALUES);
  const renderedSubject = renderNamedTemplate(subject ?? '', MESSAGE_TEMPLATE_PREVIEW_VALUES);
  if (channelKind === 'SMS') {
    const chars = bodyText.length;
    const segments = Math.max(1, Math.ceil(chars / CAMPAIGN_MESSAGE_TEMPLATE_LIMITS.smsSegmentChars));
    return (
      <div className='space-y-2'>
        <p className='text-xs font-medium uppercase tracking-wide text-muted-foreground'>Preview</p>
        <div className='max-w-sm rounded-2xl bg-muted px-4 py-3 text-sm whitespace-pre-wrap'>{renderedBody || ' '}</div>
        <p className='text-xs text-muted-foreground'>
          {chars}/{CAMPAIGN_MESSAGE_TEMPLATE_LIMITS.smsBodyMax} · {segments} SMS (tramos de{' '}
          {CAMPAIGN_MESSAGE_TEMPLATE_LIMITS.smsSegmentChars})
        </p>
      </div>
    );
  }
  return (
    <div className='space-y-2'>
      <p className='text-xs font-medium uppercase tracking-wide text-muted-foreground'>Preview</p>
      <div className='rounded-xl border bg-background shadow-sm'>
        <div className='border-b px-4 py-2 text-sm'>
          <span className='text-muted-foreground'>Asunto · </span>
          {renderedSubject || 'Sin asunto'}
        </div>
        <div className='px-4 py-3 text-sm whitespace-pre-wrap'>{renderedBody || ' '}</div>
      </div>
    </div>
  );
}
